import { atom } from 'jotai';
import type { SearchStackParamList } from '../../../Navigator';

export const searchHelperParamsAtom = atom<
  SearchStackParamList['SearchHelper']
>({
  instanceId: undefined,
  query: undefined,
  delivery_type: undefined,
  search_type: undefined,
  from_screen: undefined,
  filter_token: undefined,
});
